import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d993250"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OverlayCart" }
const _hoisted_2 = { class: "OverlayCart_Util" }
const _hoisted_3 = {
  key: 0,
  class: "OverlayCart_Util_Total"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OverlayCart_Util_Total_Title" }, "合計点数", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OverlayCart_Util_Total_Title" }, "合計数", -1))
const _hoisted_6 = { class: "OverlayCart_Container" }
const _hoisted_7 = { class: "content_title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "カート内容", -1))
const _hoisted_9 = { class: "leftContent" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "property" }, "ISBN13桁", -1))
const _hoisted_11 = { class: "rightContent" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "property" }, "本体価格", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "property" }, "数量", -1))
const _hoisted_14 = { key: 1 }

import { NormalItem } from "@/types/order";
import axios from "axios";
import { PropType, computed } from "vue";
import { useStore } from "vuex";

// 初期設定----------

export default /*#__PURE__*/_defineComponent({
  __name: 'OverlayCart',
  props: {
  normalCartData: { type: Array as PropType<NormalItem[]> },
},
  emits: ["transNormalCart", "onClose", "reloadCart"],
  setup(__props, { emit: __emit }) {

const props = __props;
const store = useStore();
//Emitの定義
const emit = __emit;

// 合計表示関連-----------------
const totalItem = computed(() => props.normalCartData?.length);
const totalNumber = computed(() => {
  let total = 0;
  props.normalCartData?.forEach((cart) => {
    total += Number(cart.quantity);
  });
  return total;
});

// 削除関連-----------------------
const deleteItem = async (item: any) => {
  if (confirm(`「${item.title}」の注文を削除してもよろしいですか？`)) {
    try {
      await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/deleteChumonId`,
        [item.juchuCartId],
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      emit("reloadCart");
    } catch (error) {
      alert("削除に失敗しました");
      console.log(error);
    }
  }
};
const deleteAllItems = async () => {
  if (confirm(`全ての注文を削除してもよろしいですか？`)) {
    try {
      await axios.delete(
        `${store.getters["getBaseUrl"]}/chumon/deleteNormalChumonAll`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      emit("reloadCart");
    } catch (error) {
      alert("削除に失敗しました");
      console.log(error);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('transNormalCart'))),
        class: "OrderSearch_Table_Button"
      }, " カート照会画面へ "),
      (__props.normalCartData !== undefined && __props.normalCartData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, [
              _hoisted_4,
              _createTextVNode("：" + _toDisplayString(totalItem.value) + "点 ", 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_5,
              _createTextVNode("：" + _toDisplayString(totalNumber.value) + "冊 ", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_font_awesome_icon, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClose'))),
        class: "close",
        icon: "xmark"
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        (__props.normalCartData !== undefined && __props.normalCartData.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: deleteAllItems,
              class: "content_title_btn"
            }, " 全て削除 "))
          : _createCommentVNode("", true)
      ]),
      (__props.normalCartData !== undefined && __props.normalCartData.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.normalCartData, (result, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "content_container",
              key: index
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, [
                    _hoisted_10,
                    _createTextVNode(_toDisplayString(result.janCd), 1)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(result.title), 1)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_font_awesome_icon, {
                    onClick: ($event: any) => (deleteItem(result)),
                    class: "trash_icon",
                    icon: "trash-can"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", null, [
                  _hoisted_12,
                  _createTextVNode("¥" + _toDisplayString(result.hontaiPrice.toLocaleString()), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_13,
                  _createTextVNode(_toDisplayString(result.quantity), 1)
                ])
              ])
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, "カート内容がありません"))
    ])
  ]))
}
}

})